import {
    generateUUID
  } from 'store/functions/geoJsonFunctions.js';

import generic_backend_request_post from 'functions/server/generic_backend_request_post';

async function saveInstance(state, instanceName, userId, scenarioId, overwrite = false) {
    if (!instanceName) {
        throw new Error('Instance name is required for save_instance');
    }
    if (!state) {
        throw new Error('State is required for save_instance');
    }
    if (!userId) {
        throw new Error('User ID is required for save_instance');
    }
    if (!scenarioId) {
        scenarioId = generateUUID();
    }

    const missingFields = [];

    if (!state) missingFields.push('input_object');
    if (!instanceName) missingFields.push('instance_name');
    if (!userId) missingFields.push('user_id');
    if (!scenarioId) missingFields.push('instance_id');

    if (missingFields.length > 0) {
        throw new Error(`Missing required fields: ${missingFields.join(', ')}`);
    }

    // Validate types
    if (typeof state !== 'object') {
        throw new Error('input_object must be an object');
    }
    if (typeof instanceName !== 'string') {
        throw new Error('instance_name must be a string');
    }
    if (typeof userId !== 'string') {
        throw new Error('user_id must be a string');
    }
    if (typeof scenarioId !== 'string') {
        throw new Error('instance_id must be a string');
    }
    if (typeof overwrite !== 'boolean') {
        throw new Error('overwrite must be a boolean');
    }
    const requestJson = {
        "input_object": state,
        "instance_name": instanceName,
        "user_id": userId,
        "instance_id": scenarioId,
        "overwrite": overwrite
    }
    const retJson = await generic_backend_request_post(requestJson, '/save_instance');
    return retJson;
}

export default saveInstance;